import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
            首页
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const category = categories.find((c) => c.slug === item.path?.replace('/category/', ''));
          const label = category ? category.name : item.label;

          return (
            <li key={index} className="flex items-center gap-1">
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              {isLast ? (
                <span className="text-foreground-900 font-medium" aria-current="page">
                  {label}
                </span>
              ) : (
                <Link to={item.path || '/'} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}